<template>
    <tbody>
        <tr v-for="item in list" v-bind:key="item.key">
            <td colspan="2">{{ item.date }}</td>
            <td>{{ item.apronTotal }}</td>
            <td class="out">{{ item.apronRemain }}</td>
            <td>{{ item.teeTotal }}</td>
            <td class="out">{{ item.teeRemain }}</td>
            <td>{{ item.t_shirtTotal }}</td>
            <td class="out">{{ item.t_shirtRemain }}</td>
            <td>{{ item.leggingsTotal }}</td>
            <td class="out">{{ item.leggingsRemain }}</td>
            <td>{{ item.skirtTotal }}</td>
            <td class="out">{{ item.skirtRemain }}</td>
            <td>{{ item.faceMaskTotal }}</td>
            <td class="out">{{ item.faceMaskRemain }}</td>
            <td>{{ item.ovenMittsTotal }}</td>
            <td class="out">{{ item.ovenMittsRemain }}</td>
            <td>{{ item.socksTotal }}</td>
            <td class="out">{{ item.socksRemain }}</td>
            <td>{{ item.toteTotal }}</td>
            <td class="out">{{ item.toteRemain }}</td>
            <td>{{ item.necklaceTotal }}</td>
            <td class="out">{{ item.necklaceRemain }}</td>
            <td>{{ item.lunchbagTotal }}</td>
            <td class="out">{{ item.lunchbagRemain }}</td>
            <td>{{ item.deskMatTotal }}</td>
            <td class="out">{{ item.deskMatRemain }}</td>
            <td>{{ item.mousePadTotal }}</td>
            <td class="out">{{ item.mousePadRemain }}</td>
            <td>{{ item.blanketTotal }}</td>
            <td class="out">{{ item.blanketRemain }}</td>
            <td>{{ item.pillowTotal }}</td>
            <td class="out">{{ item.pillowRemain }}</td>
            <td>{{ item.pillowFilledTotal }}</td>
            <td class="out">{{ item.pillowFilledRemain }}</td>
            <td>{{ item.coasterTotal }}</td>
            <td class="out">{{ item.coasterRemain }}</td>
            <td>{{ item.ornamentTotal }}</td>
            <td class="out">{{ item.ornamentRemain }}</td>
            <td>{{ item.storageBoxTotal }}</td>
            <td class="out">{{ item.storageBoxRemain }}</td>
            <td>{{ item.canvasTotal }}</td>
            <td class="out">{{ item.canvasRemain }}</td>
            <td>{{ item.phoneCaseTotal }}</td>
            <td class="out">{{ item.phoneCaseRemain }}</td>
            <td>{{ item.keyChainTotal }}</td>
            <td class="out">{{ item.keyChainRemain }}</td>
            <td>{{ item.tableClothTotal }}</td>
            <td class="out">{{ item.tableClothRemain }}</td>
            <td>{{ item.allTotal }}</td>
            <td class="out">{{ item.totalRemain }}</td>
        </tr>
    </tbody>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
    name: "DataTableNDW",
    data() {
        return {
            list: []
        }
    },
	methods: {
		async updateSelCompany() {
			let result = await axios.get('https://new.colorwayrb.com/backend/summary.php?sessionid=' + (this.$store.getters.sessionid)  + '&customer=' + this.selCompany )
			
			var allItems = result.data
			
			if (allItems == null) {
				this.list = [];
			}
			
			
			
			console.log(allItems)

			//Finds all Non-Drinkware
			var notDrinkware = allItems.filter(function (el) {
				return el.isDrinkware == false;
			})

			//Data into date arrays
			var ids = notDrinkware.map(e => e.date).filter((x, i, a) => a.indexOf(x) == i);
			var notDrinkwareDates = {};

			ids.forEach(i => {
				notDrinkwareDates[i] = notDrinkware.filter(e => {
					return e.date === i;
				});
			});

			//Finds key for dates e.g keys[1]
			var keys = Object.keys(notDrinkwareDates);
			console.log(keys)

			var allNonDrinkware = [];

			for (var i = 0; i < keys.length; i++) {

				//Filter Apron
				var apron = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'AOP Apron'
						|| el.sku == 'C0601009'
						|| el.sku == 'C0601009-BG'
						|| el.sku == 'C0601009-BL'
						|| el.sku == 'C0601009-PK'
						|| el.sku == 'C0601009-WH'
						;
				})
				console.log(apron)
				//Gets reaming and total sums Apron
				var apronRemainAmount = 0;
				var apronTotalAmount = 0;

				apron.forEach(function (el) {
					apronRemainAmount = apronRemainAmount + el.qty.remain
					apronTotalAmount = apronTotalAmount + parseInt(el.qty.total);

					return apronRemainAmount, apronTotalAmount
				})

				//Filter Tee
				var tee = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'AOP Graphic tee black sleeves-L'
						|| el.sku == 'AOP Graphic tee black sleeves-M'
						|| el.sku == 'AOP Graphic tee black sleeves-S'
						|| el.sku == 'AOP Graphic tee black sleeves-XL'
						|| el.sku == 'AOP Graphic tee black sleeves-XS'
						|| el.sku == 'AOP Graphic tee white sleeves-L'
						|| el.sku == 'AOP Graphic tee white sleeves-M'
						|| el.sku == 'AOP Graphic tee white sleeves-S'
						|| el.sku == 'AOP Graphic tee white sleeves-XL'
						|| el.sku == 'AOP Graphic tee white sleeves-XS'
						;
				})
				//Gets reaming and total sums Tee
				var teeRemainAmount = 0;
				var teeTotalAmount = 0;
				tee.forEach(function (el) {
					teeRemainAmount = teeRemainAmount + el.qty.remain
					teeTotalAmount = teeTotalAmount + parseInt(el.qty.total);

					return teeRemainAmount, teeTotalAmount
				})

				//Filter T-shirt
				var t_shirt = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0302017-BK-3XL'
						|| el.sku == 'N0302017-BK-L'
						|| el.sku == 'AN0302017-BK-M'
						|| el.sku == 'N0302017-BK-S'
						|| el.sku == 'N0302017-BK-XL'
						|| el.sku == 'N0302017-BK-XS'
						|| el.sku == 'N0302017-BK-XXL'
						|| el.sku == 'N0302017-WH-3XL'
						|| el.sku == 'N0302017-WH-L'
						|| el.sku == 'N0302017-WH-M'
						|| el.sku == 'N0302017-WH-S'
						|| el.sku == 'N0302017-WH-XL'
						|| el.sku == 'N0302017-WH-XS'
						|| el.sku == 'N0302017-WH-XXL'
						|| el.sku == 'N1002009-BK-L'
						|| el.sku == 'N1002009-BK-M'
						|| el.sku == 'N1002009-BK-S'
						|| el.sku == 'N1002009-BK-XL'
						|| el.sku == 'N1002009-BK-XS'
						|| el.sku == 'N1002009-WH-L'
						|| el.sku == 'N1002009-WH-M'
						|| el.sku == 'N1002009-WH-S'
						|| el.sku == 'N1002009-WH-XL'
						|| el.sku == 'N1002009-WH-XS'
						|| el.sku == 'N1002009-BK-L'
						|| el.sku == 'N1002009-BK-M'
						|| el.sku == 'N1002009-BK-S'
						|| el.sku == 'N1002009-BK-XL'
						|| el.sku == 'N1002009-BK-XS'
						|| el.sku == 'N1002009-WH-L'
						|| el.sku == 'N1002009-WH-M'
						|| el.sku == 'N1002009-WH-S'
						|| el.sku == 'N1002009-WH-XL'
						|| el.sku == 'N1002009-WH-XS'
						;
				})
				//Gets reaming and total sums T-shirt
				var t_shirtRemainAmount = 0;
				var t_shirtTotalAmount = 0;
				t_shirt.forEach(function (el) {
					t_shirtRemainAmount = t_shirtRemainAmount + el.qty.remain
					t_shirtTotalAmount = t_shirtTotalAmount + parseInt(el.qty.total);

					return t_shirtRemainAmount, t_shirtTotalAmount
				})

				//Filter Leggings
				var leggings = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'C0201015-L'
						|| el.sku == 'C0201015-M'
						|| el.sku == 'C0201015-S'
						|| el.sku == 'C0201015-XL'
						|| el.sku == 'C0201015-XS'
						|| el.sku == 'C0201015-XXL'
						;
				})
				//Gets reaming and total sums Leggings
				var leggingsRemainAmount = 0;
				var leggingsTotalAmount = 0;
				leggings.forEach(function (el) {
					leggingsRemainAmount = leggingsRemainAmount + el.qty.remain
					leggingsTotalAmount = leggingsTotalAmount + parseInt(el.qty.total);

					return leggingsRemainAmount, leggingsTotalAmount
				})

				//Filter Skirt
				var skirt = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'C0201013-L'
						|| el.sku == 'C0201013-M'
						|| el.sku == 'C0201013-S'
						|| el.sku == 'C0201013-XL'
						|| el.sku == 'C0201013-XS'
						|| el.sku == 'C0201013-XXL'
						;
				})
				//Gets reaming and total sums Skirt
				var skirtRemainAmount = 0;
				var skirtTotalAmount = 0;
				skirt.forEach(function (el) {
					skirtRemainAmount = skirtRemainAmount + el.qty.remain
					skirtTotalAmount = skirtTotalAmount + parseInt(el.qty.total);

					return skirtRemainAmount, skirtTotalAmount
				})

				//Filter Face Mask
				var faceMask = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0701008'
						|| el.sku == 'Fabric Mask'
						;
				})
				//Gets reaming and total sums Face Mask
				var faceMaskRemainAmount = 0;
				var faceMaskTotalAmount = 0;
				faceMask.forEach(function (el) {
					faceMaskRemainAmount = faceMaskRemainAmount + el.qty.remain
					faceMaskTotalAmount = faceMaskTotalAmount + parseInt(el.qty.total);

					return faceMaskRemainAmount, faceMaskTotalAmount
				})

				//Filter Oven Mitts
				var ovenMitts = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0601030';
				})
				//Gets reaming and total sums Oven Mitts
				var ovenMittsRemainAmount = 0;
				var ovenMittsTotalAmount = 0;
				ovenMitts.forEach(function (el) {
					ovenMittsRemainAmount = ovenMittsRemainAmount + el.qty.remain
					ovenMittsTotalAmount = ovenMittsTotalAmount + parseInt(el.qty.total);

					return ovenMittsRemainAmount, ovenMittsTotalAmount
				})

				//Filter Socks
				var socks = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0401003-40';
				})
				//Gets reaming and total sums Socks
				var socksRemainAmount = 0;
				var socksTotalAmount = 0;
				socks.forEach(function (el) {
					socksRemainAmount = socksRemainAmount + el.qty.remain
					socksTotalAmount = socksTotalAmount + parseInt(el.qty.total);

					return socksRemainAmount, socksTotalAmount
				})

				//Filter Tote
				var tote = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'cotton-tote-bag'
						|| el.sku == 'C0401017-BG-L'
						|| el.sku == 'C0401017-BG-M'
						|| el.sku == 'C0401017-BG-S'
						|| el.sku == 'C0401017-BL-L'
						|| el.sku == 'C0401017-BL-M'
						|| el.sku == 'C0401017-BL-S'
						|| el.sku == 'C0401017-L'
						|| el.sku == 'C0401017-M'
						|| el.sku == 'C0401017-S'
						|| el.sku == 'C0401017-PK-L'
						|| el.sku == 'C0401017-PK-M'
						|| el.sku == 'C0401017-PK-S'
						|| el.sku == 'C0401017-WH-L'
						|| el.sku == 'C0401017-WH-M'
						|| el.sku == 'C0401017-WH-S'
						;
				})
				//Gets reaming and total sums Tote
				var toteRemainAmount = 0;
				var toteTotalAmount = 0;
				tote.forEach(function (el) {
					toteRemainAmount = toteRemainAmount + el.qty.remain
					toteTotalAmount = toteTotalAmount + parseInt(el.qty.total);

					return toteRemainAmount, toteTotalAmount
				})

				//Filter Necklace
				var necklace = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0401007-SL-EP';
				})
				//Gets reaming and total sums Necklace
				var necklaceRemainAmount = 0;
				var necklaceTotalAmount = 0;
				necklace.forEach(function (el) {
					necklaceRemainAmount = necklaceRemainAmount + el.qty.remain
					necklaceTotalAmount = necklaceTotalAmount + parseInt(el.qty.total);

					return necklaceRemainAmount, necklaceTotalAmount
				})

				//Filter Lunchbag
				var lunchbag = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0401001-BK';
				})
				//Gets reaming and total sums Lunchbag
				var lunchbagRemainAmount = 0;
				var lunchbagTotalAmount = 0;
				lunchbag.forEach(function (el) {
					lunchbagRemainAmount = lunchbagRemainAmount + el.qty.remain
					lunchbagTotalAmount = lunchbagTotalAmount + parseInt(el.qty.total);

					return lunchbagRemainAmount, lunchbagTotalAmount
				})

				//Filter DeskMat
				var deskMat = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0801007-4080';
				})
				//Gets reaming and total sums DeskMat
				var deskMatRemainAmount = 0;
				var deskMatTotalAmount = 0;
				deskMat.forEach(function (el) {
					deskMatRemainAmount = deskMatRemainAmount + el.qty.remain
					deskMatTotalAmount = deskMatTotalAmount + parseInt(el.qty.total);

					return deskMatRemainAmount, deskMatTotalAmount
				})

				//Filter MousePad
				var mousePad = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0801007-2420';
				})
				//Gets reaming and total sums MousePad
				var mousePadRemainAmount = 0;
				var mousePadTotalAmount = 0;
				mousePad.forEach(function (el) {
					mousePadRemainAmount = mousePadRemainAmount + el.qty.remain
					mousePadTotalAmount = mousePadTotalAmount + parseInt(el.qty.total);

					return mousePadRemainAmount, mousePadTotalAmount
				})

				//Filter Blanket
				var blanket = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0601004-L'
						|| el.sku == 'N0601004-M'
						|| el.sku == 'N0601004-S'
						|| el.sku == 'GN0601004-S'
						|| el.sku == 'GN0601004-M'
						|| el.sku == 'GN0601004-L'
						|| el.sku == 'Fleece-Blanket-L'
						|| el.sku == 'Fleece-Blanket-M'
						|| el.sku == 'Fleece-Blanket-S';
				})
				//Gets reaming and total sums Blanket
				var blanketRemainAmount = 0;
				var blanketTotalAmount = 0;
				blanket.forEach(function (el) {
					blanketRemainAmount = blanketRemainAmount + el.qty.remain
					blanketTotalAmount = blanketTotalAmount + parseInt(el.qty.total);

					return blanketRemainAmount, blanketTotalAmount
				})

				//Filter Pillow
				var pillow = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'C0601006-L'
						|| el.sku == 'C0601006-M'
						|| el.sku == 'C0601006-S'
						|| el.sku == 'C0601006-24'
						|| el.sku == 'C0601006-26'
						|| el.sku == 'C0601006-36'
						|| el.sku == 'Spun-Polyester-square-pillow-16x16'
						|| el.sku == 'Spun-Polyester-square-pillow-18x18'
						|| el.sku == 'Spun-Polyester-square-pillow-20x20'
						|| el.sku == 'Spun-Polyester-square-pillow-24x24'
						|| el.sku == 'Spun-Polyester-square-pillow-26x26';
				})
				//Gets reaming and total sums Pillow
				var pillowRemainAmount = 0;
				var pillowTotalAmount = 0;
				pillow.forEach(function (el) {
					pillowRemainAmount = pillowRemainAmount + el.qty.remain
					pillowTotalAmount = pillowTotalAmount + parseInt(el.qty.total);

					return pillowRemainAmount, pillowTotalAmount
				})

				//Filter PillowFilled
				var pillowFilled = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'C0601006-L-F'
						|| el.sku == 'C0601006-M-F'
						|| el.sku == 'C0601006-S-F'
						|| el.sku == 'C0601006-24-F'
						|| el.sku == 'C0601006-26-F'
						|| el.sku == 'C0601006-36-F'
						|| el.sku == 'Spun-Polyester-square-pillow-16x16-filled'
						|| el.sku == 'Spun-Polyester-square-pillow-18x18-filled'
						|| el.sku == 'Spun-Polyester-square-pillow-20x20-filled'
						|| el.sku == 'Spun-Polyester-square-pillow-24x24-filled'
						|| el.sku == 'Spun-Polyester-square-pillow-26x26-filled';
				})
				//Gets reaming and total sums PillowFilled
				var pillowFilledRemainAmount = 0;
				var pillowFilledTotalAmount = 0;
				pillowFilled.forEach(function (el) {
					pillowFilledRemainAmount = pillowFilledRemainAmount + el.qty.remain
					pillowFilledTotalAmount = pillowFilledTotalAmount + parseInt(el.qty.total);

					return pillowFilledRemainAmount, pillowFilledTotalAmount
				})

				//Filter Coaster
				var coaster = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0601003-95SQ-4'
						|| el.sku == 'N0601003-95SQ-6'
						|| el.sku == 'Coaster-set-4';
				})
				//Gets reaming and total sums Coaster
				var coasterRemainAmount = 0;
				var coasterTotalAmount = 0;
				coaster.forEach(function (el) {
					coasterRemainAmount = coasterRemainAmount + el.qty.remain
					coasterTotalAmount = coasterTotalAmount + parseInt(el.qty.total);

					return coasterRemainAmount, coasterTotalAmount
				})

				//Filter Ornament
				var ornament = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0601022-HT7'
						|| el.sku == 'N0601022-RD7'
						|| el.sku == 'N0601028-S1'
						|| el.sku == 'N0601029-S1'
						|| el.sku == 'N0601024-S1';
				})
				//Gets reaming and total sums Ornament
				var ornamentRemainAmount = 0;
				var ornamentTotalAmount = 0;
				ornament.forEach(function (el) {
					ornamentRemainAmount = ornamentRemainAmount + el.qty.remain
					ornamentTotalAmount = ornamentTotalAmount + parseInt(el.qty.total);

					return ornamentRemainAmount, ornamentTotalAmount
				})

				//Filter StorageBox
				var storageBox = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'C0601007-33';
				})
				//Gets reaming and total sums StorageBox
				var storageBoxRemainAmount = 0;
				var storageBoxTotalAmount = 0;
				storageBox.forEach(function (el) {
					storageBoxRemainAmount = storageBoxRemainAmount + el.qty.remain
					storageBoxTotalAmount = storageBoxTotalAmount + parseInt(el.qty.total);

					return storageBoxRemainAmount, storageBoxTotalAmount
				})

				//Filter Canvas
				var canvas = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0903001-0808'
						|| el.sku == 'N0903001-0810'
						|| el.sku == 'N0903001-0812'
						|| el.sku == 'N0903001-0824'
						|| el.sku == 'N0903001-1114'
						|| el.sku == 'N0903001-1212'
						|| el.sku == 'N0903001-1216'
						|| el.sku == 'N0903001-1218'
						|| el.sku == 'N0903001-1224'
						|| el.sku == 'N0903001-1236'
						|| el.sku == 'N0903001-1240'
						|| el.sku == 'N0903001-1616'
						|| el.sku == 'N0903001-1620'
						|| el.sku == 'N0903001-1624'
						|| el.sku == 'N0903001-1632'
						|| el.sku == 'N0903001-1824'
						|| el.sku == 'N0903001-2020'
						|| el.sku == 'N0903001-2024'
						|| el.sku == 'N0903001-2028'
						|| el.sku == 'N0903001-2030'
						|| el.sku == 'N0903001-2040'
						|| el.sku == 'N0903001-2424'
						|| el.sku == 'N0903001-2430'
						|| el.sku == 'N0903001-2432'
						|| el.sku == 'N0903001-2436'
						|| el.sku == 'N0903001-3248'
						;
				})
				//Gets reaming and total sums Canvas
				var canvasRemainAmount = 0;
				var canvasTotalAmount = 0;
				canvas.forEach(function (el) {
					canvasRemainAmount = canvasRemainAmount + el.qty.remain
					canvasTotalAmount = canvasTotalAmount + parseInt(el.qty.total);

					return canvasRemainAmount, canvasTotalAmount
				})

				//Filter Phone Case
				var phoneCase = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0801002-11-ST';
				})
				//Gets reaming and total sums Phone Case
				var phoneCaseRemainAmount = 0;
				var phoneCaseTotalAmount = 0;
				phoneCase.forEach(function (el) {
					phoneCaseRemainAmount = phoneCaseRemainAmount + el.qty.remain
					phoneCaseTotalAmount = phoneCaseTotalAmount + parseInt(el.qty.total);

					return phoneCaseRemainAmount, phoneCaseTotalAmount
				})

				//Filter Key Chain
				var keyChain = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0401008-S2';
				})
				//Gets reaming and total sums Key Chain
				var keyChainRemainAmount = 0;
				var keyChainTotalAmount = 0;
				keyChain.forEach(function (el) {
					keyChainRemainAmount = keyChainRemainAmount + el.qty.remain
					keyChainTotalAmount = keyChainTotalAmount + parseInt(el.qty.total);

					return keyChainRemainAmount, keyChainTotalAmount
				})

				//Filter Table Cloth
				var tableCloth = notDrinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'N0601013-SQ140';
				})
				//Gets reaming and total sums Table Cloth
				var tableClothRemainAmount = 0;
				var tableClothTotalAmount = 0;
				tableCloth.forEach(function (el) {
					tableClothRemainAmount = tableClothRemainAmount + el.qty.remain
					tableClothTotalAmount = tableClothTotalAmount + parseInt(el.qty.total);

					return tableClothRemainAmount, tableClothTotalAmount
				})





				var allTotal =
					apronTotalAmount +
					teeTotalAmount +
					t_shirtTotalAmount +
					leggingsTotalAmount +
					skirtTotalAmount +
					faceMaskTotalAmount +
					ovenMittsTotalAmount +
					socksTotalAmount +
					toteTotalAmount +
					necklaceTotalAmount +
					lunchbagTotalAmount +
					deskMatTotalAmount +
					mousePadTotalAmount +
					blanketTotalAmount +
					pillowTotalAmount +
					pillowFilledTotalAmount +
					coasterTotalAmount +
					ornamentTotalAmount +
					storageBoxTotalAmount +
					canvasTotalAmount +
					phoneCaseTotalAmount +
					keyChainTotalAmount +
					tableClothTotalAmount;

				var totalRemain =
					apronRemainAmount +
					teeRemainAmount +
					t_shirtRemainAmount +
					leggingsRemainAmount +
					skirtRemainAmount +
					faceMaskRemainAmount +
					ovenMittsRemainAmount +
					socksRemainAmount +
					toteRemainAmount +
					necklaceRemainAmount +
					lunchbagRemainAmount +
					deskMatRemainAmount +
					mousePadRemainAmount +
					blanketRemainAmount +
					pillowRemainAmount +
					pillowFilledRemainAmount +
					coasterRemainAmount +
					ornamentRemainAmount +
					storageBoxRemainAmount +
					canvasRemainAmount +
					phoneCaseRemainAmount +
					keyChainRemainAmount +
					tableClothRemainAmount;

				var dates = notDrinkwareDates[keys[i]][0].date

				var eachDayItems = {
					'date': dates,
					'apronTotal': apronTotalAmount,
					'apronRemain': apronRemainAmount,
					'teeTotal': teeTotalAmount,
					'teeRemain': teeRemainAmount,
					't_shirtTotal': t_shirtTotalAmount,
					't_shirtRemain': t_shirtRemainAmount,
					'leggingsTotal': leggingsTotalAmount,
					'leggingsRemain': leggingsRemainAmount,
					'skirtTotal': skirtTotalAmount,
					'skirtRemain': skirtRemainAmount,
					'faceMaskTotal': faceMaskTotalAmount,
					'faceMaskRemain': faceMaskRemainAmount,
					'ovenMittsTotal': ovenMittsTotalAmount,
					'ovenMittsRemain': ovenMittsRemainAmount,
					'socksTotal': socksTotalAmount,
					'socksRemain': socksRemainAmount,
					'toteTotal': toteTotalAmount,
					'toteRemain': toteRemainAmount,
					'necklaceTotal': necklaceTotalAmount,
					'necklaceRemain': necklaceRemainAmount,
					'lunchbagTotal': lunchbagTotalAmount,
					'lunchbagRemain': lunchbagRemainAmount,
					'deskMatTotal': deskMatTotalAmount,
					'deskMatRemain': deskMatRemainAmount,
					'mousePadTotal': mousePadTotalAmount,
					'mousePadRemain': mousePadRemainAmount,
					'blanketTotal': blanketTotalAmount,
					'blanketRemain': blanketRemainAmount,
					'pillowTotal': pillowTotalAmount,
					'pillowRemain': pillowRemainAmount,
					'pillowFilledTotal': pillowFilledTotalAmount,
					'pillowFilledRemain': pillowFilledRemainAmount,
					'coasterTotal': coasterTotalAmount,
					'coasterRemain': coasterRemainAmount,
					'ornamentTotal': ornamentTotalAmount,
					'ornamentRemain': ornamentRemainAmount,
					'storageBoxTotal': storageBoxTotalAmount,
					'storageBoxRemain': storageBoxRemainAmount,
					'canvasTotal': canvasTotalAmount,
					'canvasRemain': canvasRemainAmount,
					'phoneCaseTotal': phoneCaseTotalAmount,
					'phoneCaseRemain': phoneCaseRemainAmount,
					'keyChainTotal': keyChainTotalAmount,
					'keyChainRemain': keyChainRemainAmount,
					'tableClothTotal': tableClothTotalAmount,
					'tableClothRemain': tableClothRemainAmount,

					'allTotal': allTotal,
					'totalRemain': totalRemain


				}
				allNonDrinkware.push(eachDayItems)
			}
			this.list = allNonDrinkware


			console.log(allNonDrinkware)
		}
	},
    async mounted() {
        let result = await axios.get('https://new.colorwayrb.com/backend/summary.php?sessionid=' + (this.$store.getters.sessionid))
        var allItems = result.data

        console.log(allItems)

        //Finds all Non-Drinkware
        var notDrinkware = allItems.filter(function (el) {
            return el.isDrinkware == false;
        })

        //Data into date arrays
        var ids = notDrinkware.map(e => e.date).filter((x, i, a) => a.indexOf(x) == i);
        var notDrinkwareDates = {};

        ids.forEach(i => {
            notDrinkwareDates[i] = notDrinkware.filter(e => {
                return e.date === i;
            });
        });

        //Finds key for dates e.g keys[1]
        var keys = Object.keys(notDrinkwareDates);
        console.log(keys)

        var allNonDrinkware = [];

        for (var i = 0; i < keys.length; i++) {

            //Filter Apron
            var apron = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'AOP Apron'
                    || el.sku == 'C0601009'
                    || el.sku == 'C0601009-BG'
                    || el.sku == 'C0601009-BL'
                    || el.sku == 'C0601009-PK'
                    || el.sku == 'C0601009-WH'
                    ;
            })
            console.log(apron)
            //Gets reaming and total sums Apron
            var apronRemainAmount = 0;
            var apronTotalAmount = 0;

            apron.forEach(function (el) {
                apronRemainAmount = apronRemainAmount + el.qty.remain
                apronTotalAmount = apronTotalAmount + parseInt(el.qty.total);

                return apronRemainAmount, apronTotalAmount
            })

            //Filter Tee
            var tee = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'AOP Graphic tee black sleeves-L'
                    || el.sku == 'AOP Graphic tee black sleeves-M'
                    || el.sku == 'AOP Graphic tee black sleeves-S'
                    || el.sku == 'AOP Graphic tee black sleeves-XL'
                    || el.sku == 'AOP Graphic tee black sleeves-XS'
                    || el.sku == 'AOP Graphic tee white sleeves-L'
                    || el.sku == 'AOP Graphic tee white sleeves-M'
                    || el.sku == 'AOP Graphic tee white sleeves-S'
                    || el.sku == 'AOP Graphic tee white sleeves-XL'
                    || el.sku == 'AOP Graphic tee white sleeves-XS'
                    ;
            })
            //Gets reaming and total sums Tee
            var teeRemainAmount = 0;
            var teeTotalAmount = 0;
            tee.forEach(function (el) {
                teeRemainAmount = teeRemainAmount + el.qty.remain
                teeTotalAmount = teeTotalAmount + parseInt(el.qty.total);

                return teeRemainAmount, teeTotalAmount
            })

            //Filter T-shirt
            var t_shirt = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0302017-BK-3XL'
                    || el.sku == 'N0302017-BK-L'
                    || el.sku == 'AN0302017-BK-M'
                    || el.sku == 'N0302017-BK-S'
                    || el.sku == 'N0302017-BK-XL'
                    || el.sku == 'N0302017-BK-XS'
                    || el.sku == 'N0302017-BK-XXL'
                    || el.sku == 'N0302017-WH-3XL'
                    || el.sku == 'N0302017-WH-L'
                    || el.sku == 'N0302017-WH-M'
                    || el.sku == 'N0302017-WH-S'
                    || el.sku == 'N0302017-WH-XL'
                    || el.sku == 'N0302017-WH-XS'
                    || el.sku == 'N0302017-WH-XXL'
                    || el.sku == 'N1002009-BK-L'
                    || el.sku == 'N1002009-BK-M'
                    || el.sku == 'N1002009-BK-S'
                    || el.sku == 'N1002009-BK-XL'
                    || el.sku == 'N1002009-BK-XS'
                    || el.sku == 'N1002009-WH-L'
                    || el.sku == 'N1002009-WH-M'
                    || el.sku == 'N1002009-WH-S'
                    || el.sku == 'N1002009-WH-XL'
                    || el.sku == 'N1002009-WH-XS'
                    || el.sku == 'N1002009-BK-L'
                    || el.sku == 'N1002009-BK-M'
                    || el.sku == 'N1002009-BK-S'
                    || el.sku == 'N1002009-BK-XL'
                    || el.sku == 'N1002009-BK-XS'
                    || el.sku == 'N1002009-WH-L'
                    || el.sku == 'N1002009-WH-M'
                    || el.sku == 'N1002009-WH-S'
                    || el.sku == 'N1002009-WH-XL'
                    || el.sku == 'N1002009-WH-XS'
                    ;
            })
            //Gets reaming and total sums T-shirt
            var t_shirtRemainAmount = 0;
            var t_shirtTotalAmount = 0;
            t_shirt.forEach(function (el) {
                t_shirtRemainAmount = t_shirtRemainAmount + el.qty.remain
                t_shirtTotalAmount = t_shirtTotalAmount + parseInt(el.qty.total);

                return t_shirtRemainAmount, t_shirtTotalAmount
            })

            //Filter Leggings
            var leggings = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'C0201015-L'
                    || el.sku == 'C0201015-M'
                    || el.sku == 'C0201015-S'
                    || el.sku == 'C0201015-XL'
                    || el.sku == 'C0201015-XS'
                    || el.sku == 'C0201015-XXL'
                    ;
            })
            //Gets reaming and total sums Leggings
            var leggingsRemainAmount = 0;
            var leggingsTotalAmount = 0;
            leggings.forEach(function (el) {
                leggingsRemainAmount = leggingsRemainAmount + el.qty.remain
                leggingsTotalAmount = leggingsTotalAmount + parseInt(el.qty.total);

                return leggingsRemainAmount, leggingsTotalAmount
            })

            //Filter Skirt
            var skirt = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'C0201013-L'
                    || el.sku == 'C0201013-M'
                    || el.sku == 'C0201013-S'
                    || el.sku == 'C0201013-XL'
                    || el.sku == 'C0201013-XS'
                    || el.sku == 'C0201013-XXL'
                    ;
            })
            //Gets reaming and total sums Skirt
            var skirtRemainAmount = 0;
            var skirtTotalAmount = 0;
            skirt.forEach(function (el) {
                skirtRemainAmount = skirtRemainAmount + el.qty.remain
                skirtTotalAmount = skirtTotalAmount + parseInt(el.qty.total);

                return skirtRemainAmount, skirtTotalAmount
            })

            //Filter Face Mask
            var faceMask = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0701008'
                    || el.sku == 'Fabric Mask'
                    ;
            })
            //Gets reaming and total sums Face Mask
            var faceMaskRemainAmount = 0;
            var faceMaskTotalAmount = 0;
            faceMask.forEach(function (el) {
                faceMaskRemainAmount = faceMaskRemainAmount + el.qty.remain
                faceMaskTotalAmount = faceMaskTotalAmount + parseInt(el.qty.total);

                return faceMaskRemainAmount, faceMaskTotalAmount
            })

            //Filter Oven Mitts
            var ovenMitts = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0601030';
            })
            //Gets reaming and total sums Oven Mitts
            var ovenMittsRemainAmount = 0;
            var ovenMittsTotalAmount = 0;
            ovenMitts.forEach(function (el) {
                ovenMittsRemainAmount = ovenMittsRemainAmount + el.qty.remain
                ovenMittsTotalAmount = ovenMittsTotalAmount + parseInt(el.qty.total);

                return ovenMittsRemainAmount, ovenMittsTotalAmount
            })

            //Filter Socks
            var socks = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0401003-40';
            })
            //Gets reaming and total sums Socks
            var socksRemainAmount = 0;
            var socksTotalAmount = 0;
            socks.forEach(function (el) {
                socksRemainAmount = socksRemainAmount + el.qty.remain
                socksTotalAmount = socksTotalAmount + parseInt(el.qty.total);

                return socksRemainAmount, socksTotalAmount
            })

            //Filter Tote
            var tote = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'cotton-tote-bag'
                    || el.sku == 'C0401017-BG-L'
                    || el.sku == 'C0401017-BG-M'
                    || el.sku == 'C0401017-BG-S'
                    || el.sku == 'C0401017-BL-L'
                    || el.sku == 'C0401017-BL-M'
                    || el.sku == 'C0401017-BL-S'
                    || el.sku == 'C0401017-L'
                    || el.sku == 'C0401017-M'
                    || el.sku == 'C0401017-S'
                    || el.sku == 'C0401017-PK-L'
                    || el.sku == 'C0401017-PK-M'
                    || el.sku == 'C0401017-PK-S'
                    || el.sku == 'C0401017-WH-L'
                    || el.sku == 'C0401017-WH-M'
                    || el.sku == 'C0401017-WH-S'
                    ;
            })
            //Gets reaming and total sums Tote
            var toteRemainAmount = 0;
            var toteTotalAmount = 0;
            tote.forEach(function (el) {
                toteRemainAmount = toteRemainAmount + el.qty.remain
                toteTotalAmount = toteTotalAmount + parseInt(el.qty.total);

                return toteRemainAmount, toteTotalAmount
            })

            //Filter Necklace
            var necklace = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0401007-SL-EP';
            })
            //Gets reaming and total sums Necklace
            var necklaceRemainAmount = 0;
            var necklaceTotalAmount = 0;
            necklace.forEach(function (el) {
                necklaceRemainAmount = necklaceRemainAmount + el.qty.remain
                necklaceTotalAmount = necklaceTotalAmount + parseInt(el.qty.total);

                return necklaceRemainAmount, necklaceTotalAmount
            })

            //Filter Lunchbag
            var lunchbag = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0401001-BK';
            })
            //Gets reaming and total sums Lunchbag
            var lunchbagRemainAmount = 0;
            var lunchbagTotalAmount = 0;
            lunchbag.forEach(function (el) {
                lunchbagRemainAmount = lunchbagRemainAmount + el.qty.remain
                lunchbagTotalAmount = lunchbagTotalAmount + parseInt(el.qty.total);

                return lunchbagRemainAmount, lunchbagTotalAmount
            })

            //Filter DeskMat
            var deskMat = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0801007-4080';
            })
            //Gets reaming and total sums DeskMat
            var deskMatRemainAmount = 0;
            var deskMatTotalAmount = 0;
            deskMat.forEach(function (el) {
                deskMatRemainAmount = deskMatRemainAmount + el.qty.remain
                deskMatTotalAmount = deskMatTotalAmount + parseInt(el.qty.total);

                return deskMatRemainAmount, deskMatTotalAmount
            })

            //Filter MousePad
            var mousePad = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0801007-2420';
            })
            //Gets reaming and total sums MousePad
            var mousePadRemainAmount = 0;
            var mousePadTotalAmount = 0;
            mousePad.forEach(function (el) {
                mousePadRemainAmount = mousePadRemainAmount + el.qty.remain
                mousePadTotalAmount = mousePadTotalAmount + parseInt(el.qty.total);

                return mousePadRemainAmount, mousePadTotalAmount
            })

            //Filter Blanket
            var blanket = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0601004-L'
                    || el.sku == 'N0601004-M'
                    || el.sku == 'N0601004-S'
                    || el.sku == 'GN0601004-S'
                    || el.sku == 'GN0601004-M'
                    || el.sku == 'GN0601004-L'
                    || el.sku == 'Fleece-Blanket-L'
                    || el.sku == 'Fleece-Blanket-M'
                    || el.sku == 'Fleece-Blanket-S';
            })
            //Gets reaming and total sums Blanket
            var blanketRemainAmount = 0;
            var blanketTotalAmount = 0;
            blanket.forEach(function (el) {
                blanketRemainAmount = blanketRemainAmount + el.qty.remain
                blanketTotalAmount = blanketTotalAmount + parseInt(el.qty.total);

                return blanketRemainAmount, blanketTotalAmount
            })

            //Filter Pillow
            var pillow = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'C0601006-L'
                    || el.sku == 'C0601006-M'
                    || el.sku == 'C0601006-S'
                    || el.sku == 'C0601006-24'
                    || el.sku == 'C0601006-26'
                    || el.sku == 'C0601006-36'
                    || el.sku == 'Spun-Polyester-square-pillow-16x16'
                    || el.sku == 'Spun-Polyester-square-pillow-18x18'
                    || el.sku == 'Spun-Polyester-square-pillow-20x20'
                    || el.sku == 'Spun-Polyester-square-pillow-24x24'
                    || el.sku == 'Spun-Polyester-square-pillow-26x26';
            })
            //Gets reaming and total sums Pillow
            var pillowRemainAmount = 0;
            var pillowTotalAmount = 0;
            pillow.forEach(function (el) {
                pillowRemainAmount = pillowRemainAmount + el.qty.remain
                pillowTotalAmount = pillowTotalAmount + parseInt(el.qty.total);

                return pillowRemainAmount, pillowTotalAmount
            })

            //Filter PillowFilled
            var pillowFilled = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'C0601006-L-F'
                    || el.sku == 'C0601006-M-F'
                    || el.sku == 'C0601006-S-F'
                    || el.sku == 'C0601006-24-F'
                    || el.sku == 'C0601006-26-F'
                    || el.sku == 'C0601006-36-F'
                    || el.sku == 'Spun-Polyester-square-pillow-16x16-filled'
                    || el.sku == 'Spun-Polyester-square-pillow-18x18-filled'
                    || el.sku == 'Spun-Polyester-square-pillow-20x20-filled'
                    || el.sku == 'Spun-Polyester-square-pillow-24x24-filled'
                    || el.sku == 'Spun-Polyester-square-pillow-26x26-filled';
            })
            //Gets reaming and total sums PillowFilled
            var pillowFilledRemainAmount = 0;
            var pillowFilledTotalAmount = 0;
            pillowFilled.forEach(function (el) {
                pillowFilledRemainAmount = pillowFilledRemainAmount + el.qty.remain
                pillowFilledTotalAmount = pillowFilledTotalAmount + parseInt(el.qty.total);

                return pillowFilledRemainAmount, pillowFilledTotalAmount
            })

            //Filter Coaster
            var coaster = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0601003-95SQ-4'
                    || el.sku == 'N0601003-95SQ-6'
                    || el.sku == 'Coaster-set-4';
            })
            //Gets reaming and total sums Coaster
            var coasterRemainAmount = 0;
            var coasterTotalAmount = 0;
            coaster.forEach(function (el) {
                coasterRemainAmount = coasterRemainAmount + el.qty.remain
                coasterTotalAmount = coasterTotalAmount + parseInt(el.qty.total);

                return coasterRemainAmount, coasterTotalAmount
            })

            //Filter Ornament
            var ornament = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0601022-HT7'
                    || el.sku == 'N0601022-RD7'
                    || el.sku == 'N0601028-S1'
                    || el.sku == 'N0601029-S1'
                    || el.sku == 'N0601024-S1';
            })
            //Gets reaming and total sums Ornament
            var ornamentRemainAmount = 0;
            var ornamentTotalAmount = 0;
            ornament.forEach(function (el) {
                ornamentRemainAmount = ornamentRemainAmount + el.qty.remain
                ornamentTotalAmount = ornamentTotalAmount + parseInt(el.qty.total);

                return ornamentRemainAmount, ornamentTotalAmount
            })

            //Filter StorageBox
            var storageBox = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'C0601007-33';
            })
            //Gets reaming and total sums StorageBox
            var storageBoxRemainAmount = 0;
            var storageBoxTotalAmount = 0;
            storageBox.forEach(function (el) {
                storageBoxRemainAmount = storageBoxRemainAmount + el.qty.remain
                storageBoxTotalAmount = storageBoxTotalAmount + parseInt(el.qty.total);

                return storageBoxRemainAmount, storageBoxTotalAmount
            })

            //Filter Canvas
            var canvas = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0903001-0808'
                    || el.sku == 'N0903001-0810'
                    || el.sku == 'N0903001-0812'
                    || el.sku == 'N0903001-0824'
                    || el.sku == 'N0903001-1114'
                    || el.sku == 'N0903001-1212'
                    || el.sku == 'N0903001-1216'
                    || el.sku == 'N0903001-1218'
                    || el.sku == 'N0903001-1224'
                    || el.sku == 'N0903001-1236'
                    || el.sku == 'N0903001-1240'
                    || el.sku == 'N0903001-1616'
                    || el.sku == 'N0903001-1620'
                    || el.sku == 'N0903001-1624'
                    || el.sku == 'N0903001-1632'
                    || el.sku == 'N0903001-1824'
                    || el.sku == 'N0903001-2020'
                    || el.sku == 'N0903001-2024'
                    || el.sku == 'N0903001-2028'
                    || el.sku == 'N0903001-2030'
                    || el.sku == 'N0903001-2040'
                    || el.sku == 'N0903001-2424'
                    || el.sku == 'N0903001-2430'
                    || el.sku == 'N0903001-2432'
                    || el.sku == 'N0903001-2436'
                    || el.sku == 'N0903001-3248'
                    ;
            })
            //Gets reaming and total sums Canvas
            var canvasRemainAmount = 0;
            var canvasTotalAmount = 0;
            canvas.forEach(function (el) {
                canvasRemainAmount = canvasRemainAmount + el.qty.remain
                canvasTotalAmount = canvasTotalAmount + parseInt(el.qty.total);

                return canvasRemainAmount, canvasTotalAmount
            })

            //Filter Phone Case
            var phoneCase = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0801002-11-ST';
            })
            //Gets reaming and total sums Phone Case
            var phoneCaseRemainAmount = 0;
            var phoneCaseTotalAmount = 0;
            phoneCase.forEach(function (el) {
                phoneCaseRemainAmount = phoneCaseRemainAmount + el.qty.remain
                phoneCaseTotalAmount = phoneCaseTotalAmount + parseInt(el.qty.total);

                return phoneCaseRemainAmount, phoneCaseTotalAmount
            })

            //Filter Key Chain
            var keyChain = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0401008-S2';
            })
            //Gets reaming and total sums Key Chain
            var keyChainRemainAmount = 0;
            var keyChainTotalAmount = 0;
            keyChain.forEach(function (el) {
                keyChainRemainAmount = keyChainRemainAmount + el.qty.remain
                keyChainTotalAmount = keyChainTotalAmount + parseInt(el.qty.total);

                return keyChainRemainAmount, keyChainTotalAmount
            })

            //Filter Table Cloth
            var tableCloth = notDrinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'N0601013-SQ140';
            })
            //Gets reaming and total sums Table Cloth
            var tableClothRemainAmount = 0;
            var tableClothTotalAmount = 0;
            tableCloth.forEach(function (el) {
                tableClothRemainAmount = tableClothRemainAmount + el.qty.remain
                tableClothTotalAmount = tableClothTotalAmount + parseInt(el.qty.total);

                return tableClothRemainAmount, tableClothTotalAmount
            })





            var allTotal =
                apronTotalAmount +
                teeTotalAmount +
                t_shirtTotalAmount +
                leggingsTotalAmount +
                skirtTotalAmount +
                faceMaskTotalAmount +
                ovenMittsTotalAmount +
                socksTotalAmount +
                toteTotalAmount +
                necklaceTotalAmount +
                lunchbagTotalAmount +
                deskMatTotalAmount +
                mousePadTotalAmount +
                blanketTotalAmount +
                pillowTotalAmount +
                pillowFilledTotalAmount +
                coasterTotalAmount +
                ornamentTotalAmount +
                storageBoxTotalAmount +
                canvasTotalAmount +
                phoneCaseTotalAmount +
                keyChainTotalAmount +
                tableClothTotalAmount;

            var totalRemain =
                apronRemainAmount +
                teeRemainAmount +
                t_shirtRemainAmount +
                leggingsRemainAmount +
                skirtRemainAmount +
                faceMaskRemainAmount +
                ovenMittsRemainAmount +
                socksRemainAmount +
                toteRemainAmount +
                necklaceRemainAmount +
                lunchbagRemainAmount +
                deskMatRemainAmount +
                mousePadRemainAmount +
                blanketRemainAmount +
                pillowRemainAmount +
                pillowFilledRemainAmount +
                coasterRemainAmount +
                ornamentRemainAmount +
                storageBoxRemainAmount +
                canvasRemainAmount +
                phoneCaseRemainAmount +
                keyChainRemainAmount +
                tableClothRemainAmount;

            var dates = notDrinkwareDates[keys[i]][0].date

            var eachDayItems = {
                'date': dates,
                'apronTotal': apronTotalAmount,
                'apronRemain': apronRemainAmount,
                'teeTotal': teeTotalAmount,
                'teeRemain': teeRemainAmount,
                't_shirtTotal': t_shirtTotalAmount,
                't_shirtRemain': t_shirtRemainAmount,
                'leggingsTotal': leggingsTotalAmount,
                'leggingsRemain': leggingsRemainAmount,
                'skirtTotal': skirtTotalAmount,
                'skirtRemain': skirtRemainAmount,
                'faceMaskTotal': faceMaskTotalAmount,
                'faceMaskRemain': faceMaskRemainAmount,
                'ovenMittsTotal': ovenMittsTotalAmount,
                'ovenMittsRemain': ovenMittsRemainAmount,
                'socksTotal': socksTotalAmount,
                'socksRemain': socksRemainAmount,
                'toteTotal': toteTotalAmount,
                'toteRemain': toteRemainAmount,
                'necklaceTotal': necklaceTotalAmount,
                'necklaceRemain': necklaceRemainAmount,
                'lunchbagTotal': lunchbagTotalAmount,
                'lunchbagRemain': lunchbagRemainAmount,
                'deskMatTotal': deskMatTotalAmount,
                'deskMatRemain': deskMatRemainAmount,
                'mousePadTotal': mousePadTotalAmount,
                'mousePadRemain': mousePadRemainAmount,
                'blanketTotal': blanketTotalAmount,
                'blanketRemain': blanketRemainAmount,
                'pillowTotal': pillowTotalAmount,
                'pillowRemain': pillowRemainAmount,
                'pillowFilledTotal': pillowFilledTotalAmount,
                'pillowFilledRemain': pillowFilledRemainAmount,
                'coasterTotal': coasterTotalAmount,
                'coasterRemain': coasterRemainAmount,
                'ornamentTotal': ornamentTotalAmount,
                'ornamentRemain': ornamentRemainAmount,
                'storageBoxTotal': storageBoxTotalAmount,
                'storageBoxRemain': storageBoxRemainAmount,
                'canvasTotal': canvasTotalAmount,
                'canvasRemain': canvasRemainAmount,
                'phoneCaseTotal': phoneCaseTotalAmount,
                'phoneCaseRemain': phoneCaseRemainAmount,
                'keyChainTotal': keyChainTotalAmount,
                'keyChainRemain': keyChainRemainAmount,
                'tableClothTotal': tableClothTotalAmount,
                'tableClothRemain': tableClothRemainAmount,

                'allTotal': allTotal,
                'totalRemain': totalRemain


            }
            allNonDrinkware.push(eachDayItems)
        }
        this.list = allNonDrinkware


        console.log(allNonDrinkware)
    },
	computed: {
		selCompany () {
			return this.$store.getters.getSummaryCompany
		}
	},
	watch: {
		selCompany(newVal, oldVal) {
			//console.log('Changed...' + newVal);
			this.updateSelCompany();
		}
	}
});
</script>

<style lang="css" scoped>

</style>